import { CheckBadgeIcon } from '@heroicons/react/16/solid';
import { useTranslation } from 'react-i18next';
import { tNoConnectionBannerProps } from './NoConnectionBanner.types';
import './NoConnectionBanner.styles.scss';

export default function NoConnectionBanner(props: tNoConnectionBannerProps) {
  const { t } = useTranslation('chat/chat');
  const { channelName, onReconnect, showReconnectButton, disconnectReason } =
    props;

  return (
    <div className="NoConnectionBanner">
      <CheckBadgeIcon className="NoConnectionBanner__Icon" />
      <div>
        {t('noConnectionBanner', { channel: channelName })}
        {disconnectReason && (
          <span className="NoConnectionBanner__Reason">
            {' '}
            {disconnectReason}
          </span>
        )}
        {showReconnectButton && (
          <button
            onClick={onReconnect}
            className="NoConnectionBanner__Button"
          >
            {t('reconnectLabel')}
          </button>
        )}
      </div>
    </div>
  );
}
